// extracted by mini-css-extract-plugin
export default {"avatar":"ListItemAvatar_avatar__bFZeB","dense":"ListItemAvatar_dense__IrA+9","right":"ListItemAvatar_right__YbBBa"};